(function () {
  const GA4_ID = 'G-XBSEPC17S7';
  const BANNER_ID = 'shopify-pc__banner';
  const PENDING_MS = 30000;
  // Until Shopify confirms an earlier choice, the banner decision is pending.
  let choiceState = 'pending';
  let bannerSeen = false;
  let pendingReported = false;
  let shopifyRetries = 0;
  let shopifyRetryScheduled = false;
  let googleTagQueued = false;
  let googleTagReady = false;
  let configuredChoice = null;

  function internalTraffic() {
    return !!(window.VecickyGtmInternalTraffic &&
      window.VecickyGtmInternalTraffic.isActive &&
      window.VecickyGtmInternalTraffic.isActive());
  }

  function stateFromShopify(value) {
    if (typeof value === 'string') {
      if (value === 'yes') return 'accepted';
      if (value === 'no') return 'rejected';
      if (value === 'no_interaction') return 'pending';
      return 'unknown';
    }
    if (!value || typeof value !== 'object') return 'unknown';
    if (value.analytics === 'yes') return 'accepted';
    if (value.analytics === 'no') return 'rejected';
    if (value.analytics === '') return 'pending';
    if (typeof value.analyticsAllowed === 'boolean') {
      return value.analyticsAllowed ? 'accepted' : 'rejected';
    }
    return 'unknown';
  }

  function storedChoice() {
    function cookie(name) {
      const prefix = name + '=';
      const item = (document.cookie || '').split(';').map(value => value.trim())
        .find(value => value.indexOf(prefix) === 0);
      return item ? JSON.parse(decodeURIComponent(item.substring(prefix.length))) : null;
    }
    try {
      const mirror = cookie('vecicky_gtm_consent');
      if (mirror) {
        if (mirror.choice_confirmed === true && typeof mirror.analytics === 'boolean') {
          return mirror.analytics ? 'accepted' : 'rejected';
        }
        // Old pixels wrote allowed:false before any choice. It cannot tell us
        // whether this person refused or has not decided; let Shopify resolve it.
        return 'unknown';
      }
      const legacy = cookie('eshop-cookies-accepted');
      if (Array.isArray(legacy)) {
        return legacy.some(value => Number(value) === 2) ? 'accepted' : 'rejected';
      }
    } catch (error) {
      return 'unknown';
    }
    return 'pending';
  }

  function refreshGoogleDefault() {
    if (!googleTagReady || internalTraffic() || typeof window.gtag !== 'function' ||
        configuredChoice === choiceState) return;
    window.gtag('config', GA4_ID, {
      send_page_view: false,
      consent_choice_state: choiceState,
    });
    configuredChoice = choiceState;
  }

  function onGoogleTagQueued() {
    if (googleTagQueued) return;
    googleTagQueued = true;
    // The loader calls this after gtm.js has been queued. This callback runs
    // after GTM processed its initial Google tag; never configure it prematurely.
    window.dataLayer.push({
      event: 'vecicky_consent_measurement_ready',
      eventCallback: function () {
        googleTagReady = true;
        refreshGoogleDefault();
      },
    });
  }

  function setState(next) {
    if (next === choiceState) return;
    choiceState = next;
    // GTM reads this value when a Google tag or GA4 Event tag fires.
    window.dataLayer.push({consent_choice_state: next});
    refreshGoogleDefault();
  }

  function applyShopifyState(value) {
    setState(stateFromShopify(value));
    const bridge = window.VecickyGtmConsent;
    if (internalTraffic() || !bridge || typeof bridge.writeMirrorCookie !== 'function' ||
        !value || typeof value !== 'object' ||
        !['yes', 'no'].includes(value.analytics) || !['yes', 'no'].includes(value.marketing)) return;
    const analytics = value.analytics === 'yes';
    const marketing = value.marketing === 'yes';
    const previous = typeof bridge.readMirrorCookie === 'function' ? bridge.readMirrorCookie() : null;
    if (!previous || previous.choice_confirmed !== true ||
        previous.analytics !== analytics || previous.marketing !== marketing) {
      // Repair old pixel cookies only after Shopify confirms both categories.
      bridge.writeMirrorCookie(analytics, marketing);
    }
  }

  function readShopifyState() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return false;
    if (typeof privacy.currentVisitorConsent === 'function') {
      applyShopifyState(privacy.currentVisitorConsent());
      return true;
    }
    if (typeof privacy.getTrackingConsent === 'function') {
      const result = privacy.getTrackingConsent();
      if (result && typeof result.then === 'function') {
        result.then(applyShopifyState).catch(function () {});
      } else {
        applyShopifyState(result);
      }
      return true;
    }
    return false;
  }

  function loadShopifyState() {
    if (readShopifyState()) return;
    const shopify = window.Shopify;
    if (shopify && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        if (!error) readShopifyState();
      });
      if (readShopifyState()) return;
    }
    if (shopifyRetryScheduled || shopifyRetries >= 50) return;
    shopifyRetryScheduled = true;
    shopifyRetries++;
    window.setTimeout(function () {
      shopifyRetryScheduled = false;
      loadShopifyState();
    }, 100);
  }

  function sendEvent(name) {
    if (internalTraffic()) return;
    window.gtag('event', name, {
      send_to: GA4_ID,
      consent_choice_state: choiceState,
    });
  }

  function bannerVisible() {
    const banner = document.getElementById(BANNER_ID);
    if (!banner || banner.getAttribute('aria-hidden') === 'true') return false;
    const style = window.getComputedStyle(banner);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function observeBanner() {
    if (bannerSeen || !bannerVisible()) return;
    bannerSeen = true;
    sendEvent('consent_banner_view');
    window.setTimeout(function () {
      if (pendingReported || choiceState !== 'pending' || !bannerVisible()) return;
      pendingReported = true;
      sendEvent('consent_banner_pending_30s');
    }, PENDING_MS);
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    const detail = event && event.detail;
    if (detail && typeof detail.analyticsAllowed === 'boolean') {
      setState(detail.analyticsAllowed ? 'accepted' : 'rejected');
    } else {
      readShopifyState();
    }
  });

  document.addEventListener('click', function (event) {
    if (!bannerVisible() || !event.target || !event.target.closest) return;
    if (event.target.closest('#shopify-pc__banner__btn-accept')) {
      sendEvent('consent_banner_accept_click');
    } else if (event.target.closest('#shopify-pc__banner__btn-decline')) {
      sendEvent('consent_banner_reject_click');
    }
  }, true);

  window.dataLayer = window.dataLayer || [];
  setState(storedChoice());
  loadShopifyState();
  if (choiceState === 'pending') {
    window.dataLayer.push({consent_choice_state: 'pending'});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadShopifyState();
      observeBanner();
    });
  } else {
    observeBanner();
  }
  new MutationObserver(observeBanner).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'],
    childList: true,
    subtree: true,
  });

  window.VecickyConsentMeasurement = {
    getState: function () { return choiceState; },
    onGoogleTagQueued: onGoogleTagQueued,
  };
})();
